module.exports = __webpack_public_path__ + "assets/img/37_1027_big.d0b01095.jpg";